import React from "react";
import TermsContent from "./TermsContent";

const Terms = () => {
	return (
		<div className="terms-page">
			<section className="hero-section bg-[#ECF2FB] flex flex-col items-center justify-center text-center py-24 md:py-32 px-6">
				<h1 className="text-4xl md:text-6xl font-SatoshiBold text-headerblue">
					Terms of Use
				</h1>
				<p className="mt-4 max-w-2xl font-SatoshiRegular text-[#475467]">
					The terms that govern your access to and use of Bankolé's web
					platform, mobile applications, and related services.
				</p>
			</section>
			<TermsContent />
		</div>
	);
};

export default Terms;
